//import React, {ChangeEvent, useState, useEffect} from "react";
import React from "react";
import "../Common/common.scss";
interface Props {
    AdminURL
}

const MIPAUsers: React.FC<Props> = (props) => {

    return (
        <div className="Planner">
            <div className="attendeelist attendeelistactive">
                <div className='ms-Grid'>
                    {props.AdminURL!=''? (
                        <div className='ms-Grid-row' style={{ padding: 15 }}>
                        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
                            <label>Click on following button to mange users in license administration</label>
                            <div>
                            Notice, a new browser window will open and take you to MIPA license managment
                            </div>
                        </div>
                        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ paddingTop: 20 }}>
                            <a className='ms-Button ms-Button--default viewswitchbtn plannertask' href={props.AdminURL} target="_blank" style={{ textDecoration: 'none' }} >
                                <i className='ms-Icon ms-Icon--OpenInNewWindow' style={{ fontSize: 14, marginRight: 8 }}></i>
                                Manage users</a>
                        </div>
                    </div>
                    ):(<div>MIPA user management is only visible for MIPA license Administrators.</div>)
                }
                    
                </div>
            </div>
        </div>
    )
};

export default MIPAUsers;